import { c as _c } from "react/compiler-runtime";
import useStaticProductCardData from 'hooks/useStaticProductCardData';
const useStaticWishlistData = t0 => {
  const $ = _c(7);
  const {
    productIds: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const productIds = t2;
  let t3;
  if ($[2] !== productIds) {
    t3 = {
      productIds,
      limit: -1
    };
    $[2] = productIds;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    loading,
    products
  } = useStaticProductCardData(t3);
  let t4;
  if ($[4] !== loading || $[5] !== products) {
    t4 = {
      loading,
      products
    };
    $[4] = loading;
    $[5] = products;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default useStaticWishlistData;